import { Currency } from '@/core/currency/interfaces';

const LYD: Currency = {
    name: 'Libyan Dinar',
    demonym: 'Libyan',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '434',
    symbol: 'LD',
    symbolNative: 'ل.د.',
    minorSingle: 'Dirham',
    minorPlural: 'Dirhams',
    ISOdigits: 3,
    decimals: 3,
    numToBasic: 1000,
    code: 'LYD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default LYD;
